import { HistoryToTransfert } from '@app/home/models/history.model';
import { SimulationType } from '@core/models/simulation-metadata.model';
import { CoreActions } from '@core/store';
import { createReducer, on } from '@ngrx/store';

import { CalculateData } from '../models/calculate-data.model';

import * as LaunchSimulationActions from './launch-simulation.actions';

export const launchSimulationFeatureKey = 'launchSimulation';

export interface State {
  loading: boolean;
  selectedSimulation: SimulationType;
  step: 'calculate' | 'transfert';
  calculateData: CalculateData;
  transfertHistory: Array<HistoryToTransfert>;
}

const initialState: State = {
  loading: false,
  selectedSimulation: null,
  step: 'calculate',
  calculateData: null,
  transfertHistory: []
};

export const reducer = createReducer(
  initialState,
  on(LaunchSimulationActions.resetState, state => initialState),
  on(
    CoreActions.toggleLaunchSimulationPanel,
    LaunchSimulationActions.selectSimulation,
    (state, { simulationType }) => ({
      ...state,
      selectedSimulation: simulationType ?? null,
      calculateData: null
    })
  ),
  on(LaunchSimulationActions.selectStep, (state, { step, data }) => ({
    ...state,
    step,
    calculateData: data ? data : state.calculateData,
    transfertHistory: [],
    loading: step === 'transfert'
  })),
  on(LaunchSimulationActions.transfertHistorySuccess, (state, { history }) => ({
    ...state,
    transfertHistory: history,
    loading: false
  })),
  on(LaunchSimulationActions.launchSimulationWithTransfert, state => ({ ...state, loading: true })),
  on(LaunchSimulationActions.launchSimulationSuccess, state => ({
    ...state,
    step: 'calculate' as 'calculate' | 'transfert',
    calculateData: null,
    loading: false
  })),
  on(LaunchSimulationActions.launchSimulationWithTransfertError, state => ({ ...state, loading: false })),
  on(LaunchSimulationActions.cancelSimulationSuccess, state => ({
    ...state,
    step: 'calculate' as 'calculate' | 'transfert'
  }))
);
